module.exports = __webpack_public_path__ + "static/img/Announcement.607300a5.svg";